"use client";
import {
  useRadioStore
} from "../__chunks/XV4RNL66.js";
import {
  RadioContextProvider
} from "../__chunks/FLYVORTY.js";
import "../__chunks/O6W3KMIU.js";
import "../__chunks/TCS6QBGM.js";
import "../__chunks/TN5Y26CD.js";
import "../__chunks/MTODTZOP.js";
import "../__chunks/PTCNA5XT.js";
import "../__chunks/FQ77EHUR.js";
import "../__chunks/WX6L4ACS.js";
import "../__chunks/SK3NAZA3.js";
import "../__chunks/3YLGPPWQ.js";

// src/radio/radio-provider.tsx
import { jsx } from "react/jsx-runtime";
function RadioProvider(props = {}) {
  const store = useRadioStore(props);
  return /* @__PURE__ */ jsx(RadioContextProvider, { value: store, children: props.children });
}
export {
  RadioProvider
};
